import { gql } from '@urql/core'

export const QUERY_NONCE = gql`
  query QueryNonce {
    nonce
  }
`
